<template>
  <nav class="site-breadcrumb" aria-label="Breadcrumb">
    <div class="site-breadcrumb__inner">
      <ol class="site-breadcrumb__list">
        <li
          v-for="(item, index) in items"
          :key="index"
          class="site-breadcrumb__item">
          <router-link
            v-if="item.path"
            :to="item.path"
            class="site-breadcrumb__link">
            {{ item.text }}
          </router-link>
          <span
            v-else
            class="site-breadcrumb__current"
            aria-current="page">{{ item.text }}</span>
        </li>
      </ol>
    </div>
  </nav>
</template>

<script>
import { getBreadcrumbItems } from '@/utils/breadcrumbs';

export default {
  name: 'SiteBreadcrumb',
  computed: {
    items() {
      return getBreadcrumbItems(this.$route);
    },
  },
};
</script>

<style scoped lang="scss">
.site-breadcrumb {
  background: #f7fafc;
  border-bottom: 1px solid #e8e8e8;
  /* 整条浅灰区域固定最小高度，内容在条内上下居中 */
  display: flex;
  align-items: center;
  min-height: 44px;
}

.site-breadcrumb__inner {
  width: 80%;
  max-width: 1080px;
  margin: 0 auto;
  padding: 10px 0;
  box-sizing: border-box;
}

.site-breadcrumb__list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 4px;
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 14px;
  line-height: 1.5;
  color: #4a5568;
}

.site-breadcrumb__item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 0;

  &:not(:last-child)::after {
    content: '/';
    color: #a0aec0;
    margin-left: 2px;
    pointer-events: none;
  }
}

.site-breadcrumb__link {
  color: #128c7e;
  text-decoration: none;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
}

.site-breadcrumb__current {
  color: #2d3748;
  font-weight: 600;
}

@media screen and (max-width: 768px) {
  .site-breadcrumb {
    min-height: 40px;
  }

  .site-breadcrumb__inner {
    width: 92%;
    padding: 8px 0;
  }

  .site-breadcrumb__list {
    font-size: 13px;
  }
}
</style>
